import React from "react";
import { MonthView } from "components/DatePicker/MonthView";
import type { Dayjs } from "dayjs";
import { type DateRateFomatted } from "apis/calendarRates";

type RangePickerVerticalProps = {
  firstMonth: Dayjs;
  datePropsFn: (date: Dayjs) => {
    selected: boolean;
    inBetweenSelected: boolean;
  };
  onHoverDate: (date: Dayjs) => void;
  onClickDate: (date: Dayjs) => void;
  dateRate: Record<string, DateRateFomatted> | null;
};

export const RangePickerVertical = ({
  firstMonth,
  datePropsFn,
  onHoverDate,
  onClickDate,
  dateRate,
}: RangePickerVerticalProps) => {
  const months = [...Array(12)].map((_, index) =>
    firstMonth.add(index, "month")
  );

  return (
    <div className="h-full mx-auto overflow-y-scroll bg-white border w-342 border-gold-disabled">
      {months.map((month, index) => (
        <div
          key={index}
          className="flex flex-col items-center border-b border-gold-disabled md:border-b-0">
          <MonthView
            month={month}
            datePropsFn={datePropsFn}
            onHoverDate={onHoverDate}
            onClickDate={onClickDate}
            plainAndScrollable
            dateRate={dateRate}
          />
        </div>
      ))}
    </div>
  );
};
